module.exports = __webpack_public_path__ + "static/img/code1.996b3d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code1.png
// module id = D5eY
// module chunks = 128